<template>
  <div class="row">
    <!-- 标题-副标题 -->
    <div class="col-md-12">
      <h4 class="title">{{title}}</h4>
      <h5 class="category">{{category}}</h5>
    </div>
    <div class="col-md-12 card">
      <div class="card-header">
        <div class="category">{{categorySecond}}</div>
      </div>

      <div class="card-body row">
        <!-- 分页 -->
        <div class="col-sm-6">
          <el-select
            class="select-default"
            style="width: 5.5em"
            v-model="pagination.perPage"
            placeholder="Per page">
            <el-option
              class="select-default"
              v-for="item in pagination.perPageOptions"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
          &nbsp;
          <div style="display: inline-block">
            <el-select
              class="el-select"
              style="width: 8em"
              v-model="currentsearchType"
              placeholder="Per page">
              <el-option
                class="select-default"
                v-for="item in searchType"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
          </div>
          <div style="display:inline-block">
            <fg-input class="input-sm"
                      placeholder="搜索"
                      v-model="searchQuery"
                      @keyup.enter="getData">
            </fg-input>
          </div>
          <p-button @click="getData">搜索</p-button>
        </div>

        <div class="col-sm-6">
          <div class="pull-right">
            <p-button type="success" @click="buildAction">
              打包
            </p-button>
          </div>
        </div>

        <!-- 表格 -->
        <div class="col-sm-12 mt-2">
          <template>
            <el-table class="table-striped"
                      :data="queriedData"
                      border
                      ref="dataTable"
                      :row-key="getRowKeys"
                      @selection-change="handleSelectionChange"

                      style="width: 100%">
              <el-table-column type="selection" v-model="course"
                               fixed>
              </el-table-column>
              <el-table-column type="expand">
                <template slot-scope="props">
                  <el-table label-position="left" inline :data="[props.row]">
                    <el-table-column label="楼层归属" prop="floor">
                    </el-table-column>
                    <el-table-column label="母包地址" prop="father_path">
                    </el-table-column>
                    <el-table-column label="母包地址上传时间" prop="apk_up_time">
                    </el-table-column>
                    <el-table-column label="资源包地址" prop="resource_path">
                    </el-table-column>
                    <el-table-column label="资源包地址上传时间" prop="resource_up_time">
                    </el-table-column>
                    <el-table-column label="签名信息" prop="sid">
                    </el-table-column>
                    <el-table-column label="操作者" prop="uid">
                    </el-table-column>
                  </el-table>
                </template>
              </el-table-column>
              <el-table-column v-for="column in tableColumns"
                               :key="column.label"
                               :min-width="column.minWidth"
                               :prop="column.prop"
                               :label="column.label">
              </el-table-column>
              <el-table-column
                :min-width="150"
                label="targetSDK版本"
              >
                <template slot-scope="props">
                  <fg-input placeholder="请输入targetSDK" v-model="props.row.target_version" @click="showTip"></fg-input>
                </template>
              </el-table-column>
              <el-table-column
                :min-width="600"
                class-name="td-actions"
                label="操作">
                <template slot-scope="props">
                  <!--                <div>-->
                  <p-button type="danger" size="sm" @click="selectChannelfile(props.row.id)">
                    <i slot="label"></i>绑定签名信息
                  </p-button>

                  <p-button type="danger" size="sm" @click="selectApk(props.row)">
                    <i slot="label"></i>选择母包
                  </p-button>
                  <p-button type="danger" size="sm" @click="cractResource(props.row)">
                    <i slot="label"></i>上传资源包
                  </p-button>
                  <p-button type="danger" size="sm" @click="resourceDownload(props.row)"
                            v-if="props.row.resource_download">
                    <i slot="label"></i>下载资源包
                  </p-button>
                  <!--                </div>-->
                  <!--                <div style="margin-top: 5px">-->
                  <p-button type="danger" size="sm" @click="addChannel(props.row)">
                    <i slot="label"></i>接入渠道
                  </p-button>
                  <p-button type="danger" size="sm" @click="channelArgs(props.row,props.row.cid)">
                    <i slot="label"></i>参数编辑
                  </p-button>
                  <p-button type="danger" size="sm" @click="deleteAction(props.row.id,$event)">
                    <i slot="label"></i>删除
                  </p-button>
                  <!--                </div>-->
                </template>
              </el-table-column>


            </el-table>
          </template>
        </div>
        <!-- 底部 -->
        <div class="col-sm-6 pagination-info">
          <p class="category">{{page}}</p>
        </div>
        <div class="col-sm-6">
          <p-pagination class="pull-right"
                        v-model="pagination.currentPage"
                        :page-count="pagination.page_count">
          </p-pagination>
        </div>
      </div>
    </div>


    <el-dialog title="资源包上传" :visible.sync="dialogResourceVisible">
      <el-upload
        class="upload-file"
        ref="upload"
        :action="resourceUploadUrl"
        :headers="getToken"
        :limit="1"
        :data="postData"
        name="resourcefile"
        :on-success="resourceupsuccess"
        :on-progress="handleProgress"
        :on-change="resourceChange"
        :file-list="resoucreList"
        :auto-upload="false">
        <div slot="tip" class="el-upload__tip">上传资源包,资源包必须以".zip"结尾</div>
        <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
        <el-button style="margin-left: 10px;" size="small" type="success" @click="resourceUpload">上传到服务器
        </el-button>

      </el-upload>
      <div slot="footer" class="dialog-footer">
      </div>
    </el-dialog>

    <el-dialog title="签名信息列表" :visible.sync="dialogChannelFileVisible">
      <el-table :data="channelFileData">
        <el-table-column v-for="column in channelFileColumns"
                         :key="column.label"
                         :min-width="column.minWidth"
                         :prop="column.prop"
                         :label="column.label">
        </el-table-column>

        <el-table-column
          :min-width="80"
          fixed="right"
          class-name="td-actions"
          label="操作">
          <template slot-scope="props">
            <p-button type="danger" size="sm" @click="selectChannelFileAction(props.row.id,$event)">
              <i slot="label"></i>选择签名信息文件
            </p-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog title="母包列表" :visible.sync="dialogapklist">
      <div class="TestWorld">
        <el-table :data="apklist" border stripe style="width: 100%;" max-height="600">
          <el-table-column prop="is_required" label="母包地址">
            <template slot-scope="scope">
              <el-input v-if="scope.row.edit" v-model="scope.row.is_required" placeholder="是否必填"></el-input>
              <span v-else>{{scope.row.is_required}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="args_key" label="上传时间">
            <template slot-scope="scope">
              <el-input v-if="scope.row.edit" v-model="scope.row.args_key" placeholder="参数键"></el-input>
              <span v-else>{{scope.row.args_key}}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <el-dialog title="渠道列表" :visible.sync="dialogSelectChannelVisible">
      <div class="col-sm-6">
        <div style="display: inline-block">

        </div>
        <div style="display:inline-block">
          <fg-input class="input-sm"
                    placeholder="搜索渠道名"
                    v-model="searchQuery_channel"
                    addon-right-icon="nc-icon nc-zoom-split" @keyup.enter="getChannelAPI">
          </fg-input>
        </div>
      </div>
      <el-table :data="channelArgsData">
        <el-table-column v-for="column in tableChannels"
                         :key="column.label"
                         :min-width="column.minWidth"
                         :prop="column.prop"
                         :label="column.label">
        </el-table-column>

        <el-table-column
          :min-width="80"
          fixed="right"
          class-name="td-actions"
          label="操作">
          <template slot-scope="props">
            <p-button type="danger" size="sm" @click="selectAction(props.row.id,$event)">
              <i slot="label"></i>选择渠道
            </p-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog title="渠道参数" :visible.sync="dialogChannelArgsVisible">
      <div class="TestWorld">
        <el-table :data="channelArgstableData" border stripe style="width: 100%;" max-height="600">
          <el-table-column prop="is_required" label="是否必填">
            <template slot-scope="scope">
              <el-input v-if="scope.row.edit" v-model="scope.row.is_required" placeholder="是否必填"></el-input>
              <span v-else>{{scope.row.is_required}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="args_key" label="参数键">
            <template slot-scope="scope">
              <el-input v-if="scope.row.edit" v-model="scope.row.args_key" placeholder="参数键"></el-input>
              <span v-else>{{scope.row.args_key}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="args_info" label="参数说明">
            <template slot-scope="scope">
              <el-input v-if="scope.row.edit" v-model="scope.row.args_info" placeholder="参数说明"></el-input>
              <span v-else>{{scope.row.args_info}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="args_value" label="参数值">
            <template slot-scope="scope">
              <el-input v-if="!scope.row.edit" v-model="scope.row.args_value" placeholder="参数值"></el-input>
              <span v-else>{{scope.row.args_value}}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-button type="primary" @click="editorCodeArgs" style="margin-bottom: 10px;">确认修改</el-button>
      </div>
    </el-dialog>

    <el-dialog title="母包列表" :visible.sync="dialogapkdata">
      <div class="col-sm-12">
        <div style="display:inline-block">
          <fg-input class="input-sm"
                    placeholder="搜索母包名"
                    v-model="searchQuery_apkname"
                    addon-right-icon="nc-icon nc-zoom-split" @keyup.enter="getAllapk">
          </fg-input>
        </div>
        <div style="display:inline-block">
          <p-button class="btn btn" @click="getAllapk">搜索</p-button>
        </div>
        <div class="pull-right" style="display:inline-block">
          <el-switch
            style="display: block"
            v-model="is_all"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-text="显示个人记录"
            inactive-text="显示全部记录">
          </el-switch>
        </div>
        <!--      </div>-->
        <el-table :data="apklist">
          <el-table-column prop="id" label="母包id">
          </el-table-column>
          <el-table-column prop="alias" label="母包名">
          </el-table-column>
          <el-table-column prop="father_path" min-width="300px" label="母包地址">
          </el-table-column>
          <el-table-column prop="up_time" min-width="150px" label="上传时间">
          </el-table-column>
          <el-table-column
            :min-width="120"
            fixed="right"
            class-name="td-actions"
            label="操作">
            <template slot-scope="props">
              <p-button type="danger" size="sm" @click="selectapkAction(props.row.id,$event)">
                <i slot="label"></i>选择母包
              </p-button>
            </template>
          </el-table-column>
        </el-table>
        <div>
          <div class="col-sm-3 pagination-info" style="display: inline-block">
            <p class="category">{{apkpage}}</p>
          </div>
          <div class="col-sm-9 pull-right" style="display: inline-block">
            <p-pagination class="pull-right"
                          v-model="apkpagination.currentPage"
                          :page-count="apkpagination.page_count">
            </p-pagination>
          </div>
        </div>
      </div>
    </el-dialog>

  </div>
</template>


<script>
  import Vue from 'vue'
  import swal from 'sweetalert2'
  import {Table, TableColumn, Select, Option, Dialog, Form, FormItem} from 'element-ui'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  import Search from 'src/components/UIComponents/Search/Search.vue'
  import {getFetch} from 'src/util/fetch'
  import {Cookie} from 'src/util/cookie'
  import PButton from "../../../UIComponents/Button";


  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)
  Vue.use(Dialog)
  Vue.use(Form)
  Vue.use(FormItem)
  export default {
    watch: {
      'pagination.perPage'() {
        this.getData()
      },
      'pagination.currentPage'() {
        this.getData()
      },
      'apkpagination.perPage'() {
        this.getAllapk()
      },
      'apkpagination.currentPage'() {
        this.getAllapk()
      },
      is_all() {
        this.getAllapk(true)
      },
    },
    components: {
      PButton,
      PPagination,
      Search,
    },
    computed: {
      channelFileData() {
        return this.searchListChannel
      },
      channelArgsData() {
        return this.channelListData
      },
      ArgsData() {
        return this.channelArgsAlone

      },
      queriedData() {
        return this.tableData
      },
      to() {
        let highBound = this.from + this.pagination.perPage
        if (this.total < highBound) {
          highBound = this.total
        }
        return highBound
      },
      from() {
        return this.pagination.perPage * (this.pagination.currentPage - 1)
      },
      total() {
        return this.total_count
      },
      page() {
        return `从 ${this.from + 1} 到 ${this.to} 共 ${this.total} 条`
      },
      apkto() {
        let highBound = this.apkfrom + this.apkpagination.perPage
        if (this.apk_total_count < highBound) {
          highBound = this.apk_total_count
        }
        return highBound
      },

      apkfrom() {
        return this.apkpagination.perPage * (this.apkpagination.currentPage - 1)
      },
      apktotal() {
        return this.apk_total_count
      },
      apkpage() {
        return `从 ${this.apkfrom + 1} 到 ${this.apkto} 共 ${this.apktotal} 条`
      }
    },
    data() {//定义tabel
      return {
        is_all: false,
        floor: "jssy",
        postData: {},
        test: [],
        fileUploadUrl: window.Config.host + '/api/games/jssygames/',
        resourceUploadUrl: window.Config.host + '/api/channel/up_resource/',
        getToken: {
          token: '',
        },
        // channelCodeData:[],
        resoucreList: [],
        title: '第四事业部打包',
        multipleTable: [],     //存放选中值的数组
        current_select_channelid: '',
        current_select_packageid: '',
        current_selectbundchannel_pid: '',
        current_selectbundchannel_gameid: '',
        //渠道参数
        channelArgstableData: [],

        category: '马甲包打包列表',
        categorySecond: '',
        dialogapklist: false,
        dialogapkdata: false,
        dialogResourceVisible: false,
        dialogChannelFileVisible: false,
        dialogSelectChannelVisible: false,
        dialogChannelArgsVisible: false,
        dialogEditorChannelArgsVisible: false,
        pagination: {//分页
          perPage: 10,
          currentPage: 1,
          perPageOptions: [5, 10, 20],
          page_count: 0,
          total: 0
        },
        searchQuery: '',//搜索值
        searchQuery_channel: '',
        currentsearchType: '游戏id',
        currentsearchChannel: "",
        searchListChannel: [],
        searchType: ['游戏id', '游戏名'],//搜索字段
        channelFileColumns: [//列表
          {
            prop: 'storeFile',
            label: '签名文件名',
            minWidth: 200
          },
        ],
        tableColumns: [//列表
          {
            prop: 'gameid',
            label: '游戏id',
            minWidth: 100
          },
          {
            prop: 'child_game_name',
            label: '游戏名',
            minWidth: 200
          },
          {
            prop: 'alias',
            label: '游戏别名',
            minWidth: 80
          },
          {
            prop: 'game_status',
            label: '游戏状态',
            minWidth: 80
          },
          {
            prop: 'cid',
            label: '渠道信息',
            minWidth: 80
          },

        ],
        tableChannels: [//渠道列表
          {
            prop: 'channel_name',
            label: '渠道名称',
            minWidth: 100
          },
          {
            prop: 'channel_code',
            label: '渠道代码',
            minWidth: 100
          },
          {
            prop: 'channel_version',
            label: '版本号',
            minWidth: 100
          },
          {
            prop: 'channel_srcipt_path',
            label: '渠道脚本地址',
            minWidth: 200
          },

        ],
        dialogData: {},
        apkData: {},
        //母包选择参数
        apklist: [],
        tableData: [],//渲染table数据
        searchQuery_apkname: '',
        apkpagination: {//apk分页
          perPage: 10,
          currentPage: 1,
          page_count: 0,
          total: 0
        },
        apk_total_count: 0,
        channelListData: [],
        //获取游戏信息批量传输给后台
        course: [],
        total_count: 0,
        //单个渠道参数
        channelArgsAlone: [],
        channelArgID: '',
        channelID: '',
        Temp: 'error',
        apkTemp: 'error',
        channel_row: '',
      }
    },
    methods: {
      showTip() {
        this.$message({
          message: 'targetSDK必须与渠道参数里的对应',
          type: 'warning',
          offset: 80,
        });

      },
      handleExpand(row) {
        this.$refs.dataTable.toggleRowExpansion(row, true) // 点击button展开
      },
      //获取表格一行的信息,未使用
      getRowKeys(row) {
        return row.id
      },
      selectapkAction(id, event) {
        this.select_apk(id)
      },
      async select_apk(aid) {
        let opt = {
          url: '/api/games/apk_select/',
          type: 'POST',
          data: {
            floor: this.floor,
            pid: this.apkData.id,
            aid: aid
          }
        }
        const res = await getFetch(this, opt);
        if (res.code === 0) {
          this.$message('母包绑定游戏成功');
          this.dialogapkdata = false
          this.getData()
          if (this.apkData) {
            this.handleExpand(this.apkData)
          }
        }
      },
      selectApk(row) {
        this.searchQuery_apkname = ''
        this.dialogapkdata = true
        this.apkData = row
        this.getAllapk()
      },
      async getAllapk(is_all = false) {
        let page = is_all ? 1 : this.apkpagination.currentPage;
        let apk_data = {}
        apk_data["is_all"] = this.is_all ? 0 : 1;
        apk_data['page'] = page
        apk_data["floor"] = this.floor
        switch (this.searchQuery_apkname) {
          case "":
            apk_data['page'] = page
            break;
          case this.Temp:
            apk_data['page'] = page
            break;
          default:
            apk_data["page"] = 1
        }
        if (this.searchQuery_apkname !== '') {
          this.apkTemp = this.searchQuery_apkname
          apk_data['alias'] = this.searchQuery_apkname
        }
        let opt = {
          url: '/api/games/apk_select/',
          type: 'GET',
          data: apk_data,
        }
        const res = await getFetch(this, opt);
        if (res.code === 0) {
          if (res.data.apks.results) {
            this.apklist = []
            this.apklist = res.data.apks.results
            this.apk_total_count = res.data.apks.total_count
            this.apkpagination.page_count = res.data.apks.total_page
          }
        }
      },
      apkupsuccess() {
        this.apklist = []
        this.dialogapkVisible = false;
        //清除属性
        swal({
          title: '上传成功!',
          type: 'success',
          confirmButtonClass: 'btn btn-success btn-fill',
          buttonsStyling: false
        })
        this.getData()
      },
      resourceupsuccess(response, file, fileList) {

        if (response.code === 0) {
          this.resoucreList = []
          this.dialogResourceVisible = false;
          //清除属性
          swal({
            title: '上传成功!',
            type: 'success',
            confirmButtonClass: 'btn btn-success btn-fill',
            buttonsStyling: false
          })
          this.getData()
          if (this.dialogData) {
            this.handleExpand(row)
          }
          this.dialogData = {}
        }

      },
      checkValue(data) {
        //console.log(data)
        let temp = []
        for (let i = 0; i < data.length; i++) {
          if (data[i].is_required == "必填") {
            if (!data[i].args_value) {
              temp.push(data[i])
            }
          }
        }
        return temp
      },
      editorCodeArgs() {
        var code_list = this.channelArgstableData

        let temp = this.checkValue(code_list)

        if (temp.length === 0) {
          for (let i = 0; i < code_list.length; i++) {
            if (code_list[i].is_required == "必填") {
              code_list[i].is_required = true
            } else if (code_list[i].is_required == "非必填") {
              code_list[i].is_required = false
            }
          }
          this.changeChannelAPI(this.current_selectbundchannel_gameid, code_list)
          this.dialogChannelArgsVisible = false
          alert("參數保存成功")
        } else {
          alert("请填上必填的参数")
        }
      },

      selectAction(id, event) {
        this.bundChannelAPI(this.current_selectbundchannel_gameid, id)
        this.dialogSelectChannelVisible = false
        // this.current_select_channelid = id
        this.getMyToken()
      },

      handleSelectionChange(val) {
        this.multipleTable = val;               //  this.multipleTable 选中的值

        //console.log(val);

      },

      //进度条
      handleProgress(event, file, fileList) {
        // console.log("122", event)
        // console.log(file.name)
        // console.log(fileList)
      },

      checkfile(file, filelist) {
        for (let i = 0; i < filelist.length; i++) {
          if (filelist[i].name === file.name) {
            filelist.splice(i, 1)
          }
        }
      },

      apkhandleChange(file, fileList) {
        if (file.name.endsWith(".apk")) {
        } else {
          alert("文件格式错误")
          this.checkfile(file, fileList)
        }
      },

      resourceChange(file, fileList) {
        if (file.name.endsWith(".zip")) {
        } else {
          alert("文件格式错误")
          this.checkfile(file, fileList)
        }
      },

      getMyToken() {
        this.getToken.token = Cookie().get("token")
      },


      async resourceUpload() {
        let _resoueceData = {
          floor: this.floor,
          pid: this.dialogData.id,
          gid: this.dialogData.gameid,
          channel_name: this.dialogData.cid
        }
        this.postData = _resoueceData;
        //console.log(this.postData, '上传')
        setTimeout(() => {
          this.$refs.upload.submit()
        }, 1000);
      },
      // cractApk(row) {
      //     this.dialogData = row;
      //     this.dialogapkVisible = true
      //     this.getMyToken()
      // },
      cractResource(row) {
        if (row.cid) {
          this.dialogData = row;
          this.dialogResourceVisible = true
          this.getMyToken()
        } else {
          alert("请先选择渠道")
        }

      },
      //资源包下载
      resourceDownload(row) {
        let path = "/download" + row.resource_path;
        // console.log(path)
        open(window.Config.host + path);
      },
      selectChannelfile(id) {
        this.current_selectbundchannel_pid = id
        this.dialogChannelFileVisible = true
        this.getMyToken()
      },

      addChannel(row) {
        this.current_select_packageid = row.id
        this.current_selectbundchannel_gameid = row.gameid
        this.dialogSelectChannelVisible = true
        this.channel_row = row
        this.getMyToken()
      },

      selectChannelFileAction(signid) {
        this.bundChannelInfoAPI(this.current_selectbundchannel_pid, signid)
        this.dialogChannelFileVisible = false
        this.getMyToken()
      },

      //查看渠道对应的渠道参数
      channelArgs(row, channelid) {
        if (row.cid) {
          this.current_selectbundchannel_gameid = row.gameid
          this.dialogChannelArgsVisible = true
          this.getChannelArgs(row.uid, row.gameid, row.cid)
          this.channelID = channelid
        } else {
          alert("请先选择渠道")
        }
      },
      //获取渠道参数
      async getChannelArgs(user, gameid, channelName) {
        let opt = {
          url: '/api/jssy/user_channel_args/',
          type: 'GET',
          data: {
            user: user,
            gid: gameid,
            channel_name: channelName
          }
        }
        const res = await getFetch(this, opt);
        if (res.code === 0) {
          this.channelArgstableData = []
          //动态渲染
          let temp = res.data.args
          for (let i = 0; i < temp.length; i++) {
            if (temp[i].is_required) {
              temp[i].is_required = "必填"
            } else {
              temp[i].is_required = "非必填"
            }
            // temp.edit= true
          }
          this.channelArgstableData = temp
        }
      },
      //编辑渠道参数
      editorChannelArgs(index, row) {
        this.dialogEditorChannelArgsVisible = true
        this.channelArgsAlone = [row]
        this.channelArgID = row.id
      },

      deleteAction(id, event) {
        this.deleteBuildGameAPI(id)
      },

      changeTotal(length) {
        this.pagination.total = length
      },

      buildAction() {
        var args_list = []
        // console.log(this.tableData)
        // console.log(this.multipleTable)
        for (var i = 0; i < this.multipleTable.length; i++) {
          if (!this.multipleTable[i].sid) {
            alert("请先选择签名信息")
            return;
          }
          if (!this.multipleTable[i].cid) {
            alert("请先选择渠道，并配置相关渠道参数")
            return;
          }
          if ((this.multipleTable[i].father_path == '未上传母包') || (this.multipleTable[i].father_path == '后台处理中')) {
            alert("母包未就绪，禁止打包")
            return;
          }
          if ((this.multipleTable[i].resource_path == '未上传资源包') || (this.multipleTable[i].resource_path == '后台处理中')) {
            alert("资源包未就绪，禁止打包")
            return;
          }

          if (this.multipleTable[i].target_version) {

            args_list.push({
              "user": this.multipleTable[i].uid,
              "id": this.multipleTable[i].id,
              "target_version": this.multipleTable[i].target_version
            })
          } else {
            alert("targetSDK不能为空")
            return;
          }

        }
        // console.log(this)
        if (args_list.length !== 0) {

          this.gameBuildAPI(args_list)
        } else {
          alert("请先选择游戏")
        }
      },

      //预打包列表API
      async getData(page, size) {
        page = this.pagination.currentPage
        size = this.pagination.perPage
        let req_data = {}
        req_data['size'] = size
        req_data['page'] = page
        switch (this.searchQuery) {
          case "":
            req_data['page'] = page
            break;
          case this.Temp:
            req_data['page'] = page
            break;
          default:
            req_data["page"] = 1
        }
        if (this.searchQuery !== '') {
          this.Temp = this.searchQuery
          if (this.currentsearchType === this.searchType[0]) {
            req_data['type'] = 1
            req_data['gid'] = this.searchQuery
          } else if (this.currentsearchType === this.searchType[1]) {
            req_data['type'] = 2
            req_data['name'] = this.searchQuery
          } else {
            console.log('预留')
          }
        }
        let opt = {
          url: "/api/jssy/package/",
          type: "get",
          data: req_data,

        }
        const res = await getFetch(this, opt);
        if (res.code === 0) {
          this.tableData = []
          var list = []
          if (res.data.packing.results) {
            for (var i = 0; i < res.data.packing.results.length; i++) {
              res.data.packing.results[i]["target_version"] = ''

              let data = res.data.packing.results[i]

              if (!data.father_path) {
                data.father_path = "未上传母包"
              } else if (data.father_path == "0") {
                data.father_path = "后台处理中"
              }
              if (!data.resource_path) {
                data["resource_download"] = false;
                data.resource_path = "未上传资源包"
              } else if (data.resource_path == "-1") {
                data["resource_download"] = false;
                data.resource_path = "上传失败"
              } else if (data.resource_path == "0") {
                data["resource_download"] = false;
                data.resource_path = "后台处理中"
              } else {
                //允许下载
                data["resource_download"] = true;
              }
              if (data.sid == "") {
                data.sid = "未绑定"
              }
              switch (data.floor) {
                case "sypt":
                  data.floor = "第一事业部"
                  break
                case "yypt":
                  data.floor = "第二事业部"
                  break
                case "jssy":
                  data.floor = "第四事业部"
              }

              if (data.game_status == "false") {
                data.game_status = "锁定"
              } else {
                data.game_status = "正常"
              }
              list.push(data)
            }
            this.tableData = list // res.data.games.results
            this.changeTotal(res.data.packing.total_count)
            this.total_count = res.data.packing.total_count
            this.pagination.page_count = res.data.packing.total_page
          } else {
            alert("没有此记录,请确定搜索条件是否正确")
          }
        }
      },

      //签名信息列表API
      async channelInfoAPI() {
        let opt = {
          url: "/api/games/sign/",
          type: "get",
        }
        const res = await getFetch(this, opt);
        if (res.code === 0) {
          this.searchListChannel = []
          this.searchListChannel = res.data.sign
        }
      },

      //游戏绑定签名信息API
      async bundChannelInfoAPI(id, signid) {
        let opt = {
          url: "/api/jssy/game_sign/",
          type: "post",
          data: {
            pid: id,
            sid: signid,
          }
        }
        const res = await getFetch(this, opt);
        if (res.code === 0) {
          this.getData();
        }
      },

      //游戏绑定渠道API
      async bundChannelAPI(gameid, channelid) {
        let opt = {
          url: "/api/jssy/game_channel/",
          type: "post",
          data: {
            pid: this.current_select_packageid,
            gid: gameid,
            cid: channelid,
          }
        }

        const res = await getFetch(this, opt);
        if (res.code === 0) {
          this.getData();
          this.handleExpand(this.channel_row)
          this.channel_row = ''
        }
      },

      //打包操作API
      async gameBuildAPI(args_list) {
        let opt = {
          url: "/api/jssy/packing/",
          type: "post",
          data: {
            args: args_list,
          }
        }
        const res = await getFetch(this, opt);

        if (res.code === 0) {
          this.$router.push('/history/jssyhistory')
        }
      },

      //修改游戏对应的渠道参数
      async changeChannelAPI(gameid, channel_args) {
        let opt = {
          url: "/api/jssy/user_channel_args/",
          type: "post",
          data: {
            gid: gameid,
            cid: this.channelID,
            args: channel_args,
          }
        }
        const res = await getFetch(this, opt);
        if (res.code === 0) {
          this.getData();
        }
      },

      //删除预打包游戏API
      async deleteBuildGameAPI(id) {
        let opt = {
          url: "/api/jssy/package/",
          type: "delete",
          data: {
            pid: id,
          }
        }
        const res = await getFetch(this, opt);
        if (res.code === 0) {
          alert("删除成功")
          this.getData();
        }
      },
      //渠道列表
      async getChannelAPI(page, size) {
        let req_data = {}
        req_data['size'] = 5000
        req_data['page'] = 1
        if (this.searchQuery_channel !== '') {
          req_data['type'] = 1
          req_data['name'] = this.searchQuery_channel
        }

        let opt = {
          url: '/api/channel/jschannel/',
          type: 'GET',
          data: req_data,
        }
        const res = await getFetch(this, opt);
        if (res.code === 0) {
          this.channelListData = []
          let temp = res.data.channel.results
          for (let i = 0; i < temp.length; i++) {
            if (temp[i].channel_srcipt_path == 0) {
              temp[i].channel_srcipt_path = "后台处理文件ing,请稍后"
            }
          }
          this.channelListData = temp
        }
      },
    },
    mounted() {
      // console.log(this.$router)
      this.getData();
      this.channelInfoAPI();
      this.getChannelAPI();
      // this.getAllapk()
      //
    }
  }
</script>

